import { render, staticRenderFns } from "./ReplacementStatistics.vue?vue&type=template&id=d60a89e2&"
import script from "./ReplacementStatistics.vue?vue&type=script&lang=js&"
export * from "./ReplacementStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports